// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";


// HRチェック画面用 汎用ファイルアップロード（type で用途識別）
const AdminHrNewsUploadApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/hr_news_upload";

    const ExecAdminHrNewsUploadApi = async (type, select_file, file_name) => {
        const requestParams = { type };

        const requestBinaryParams = {
            file: {
                file: select_file,
                filename: file_name,
            },
        };

        let response = null;
        let error = null;
        try {
            response = await ApiRequest({ url, requestParams, requestBinaryParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminHrNewsUploadApi;
};

export default AdminHrNewsUploadApi;
